import React, { useEffect, useState, useRef } from "react";
import ReactDOM from "react-dom";
import styled from "styled-components";

import config from "../../Config"
import leftimage from '../../images/arrowleft.svg'
import rightimage from '../../images/arrowright.svg'
import { Card } from "./Card";
import { secondsToHms } from "../../util/Utility";
import i18n from "../../i18n";

const TBHeader = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 0 20px;
`;

const TBTitle = styled.h2`
  font-family: "montserratRegular";
  text-align: left;
  font-size: 16px;
  font-weight: 500;
  color: #dfe4ff;
`;


const SeeAll = styled.span`
  font-family: "montserratRegular";
  text-align: left;
  font-size: 14px;
  font-weight: 500;
  color: #fb0e56;
  cursor: pointer;
  text-transform: uppercase;
`;

const ScrollContainer = styled.div`
  display: flex;
  overflow-x: auto;
  padding: 10px 0;
  scroll-behavior: smooth;
  ::-webkit-scrollbar{
    height: 7px;
   
    
}
`;



const LeftArrow = styled.button`
  /* Styles for left arrow button */
  position: absolute;
  left: 0;
  top: 50%;
  -webkit-transform: translateY(-50%);
  -ms-transform: translateY(-50%);
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 44px;
  color: #D7CCC8;

`;

const RightArrow = styled.button`
  /* Styles for right arrow button */
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  background-color: transparent;
  border: none;
  cursor: pointer;
  font-size: 44px;
  color: #D7CCC8;
`;




function HorizontalScroll({
  title,
  seeAllHandler,
  bids,
  onClick,
  // bidsType,
  theme,
}) {
  const [items, setItems] = useState([]);
  useEffect(() => {
    if (bids && bids.length > 0) {
      setItems(bids);
    }
  }, [bids]);



  const handleScrollLeft = () => {
    const containerOne = document.querySelector('.scroll-container');

    if (containerOne) {
      containerOne.scrollLeft -= 100; // Adjust the scroll distance as needed
    }
  };

  const handleScrollRight = () => {
    const containerOne = document.querySelector('.scroll-container');

    if (containerOne) {
      containerOne.scrollLeft += 100; // Adjust the scroll distance as needed
    }
  };



  let scrollTitleColor;
  if (title === "Daily Bids") {
    scrollTitleColor = "#ff7979";
  } else if (title === "Weekly Bids") {
    scrollTitleColor = "#7979ff";
  } else {
    scrollTitleColor = "#79d4ff";
  }



  return (
    <div
      style={{
        backgroundColor: theme ? theme.secondaryColor : "#ccc",
        position: "relative",
        paddingTop: "10px",
      }}
    >
      <TBHeader>
        <TBTitle>{title}</TBTitle>
        <SeeAll onClick={seeAllHandler}>{i18n.t("SeeAll")}</SeeAll>
      </TBHeader>
      <ScrollContainer className="scroll-container">
      {items.map((item) => {
          const {
            offerId,
            id,
            offerTitle,
            title,
            offerImageUrl,
            src,
            offerTimeLeft,
            timeLeft,
            alt,
            isActiveOffer,
          } = item;
         //  if (bidsType && item[bidsType]) {
            return (
              <Card
                scrollTitleColor={scrollTitleColor}
                title={offerTitle ? offerTitle : title}
                itemId={offerId ? offerId : id} // NOTE: itemId is required for track items
                key={offerId ? offerId : id}
                src={offerImageUrl ? offerImageUrl : src}
                time={offerTimeLeft ? offerTimeLeft : timeLeft}
                alt={alt ? alt : "Alt text not available"}
                horizontalScrollCard={true}
                onClick={() =>
                  isActiveOffer === "true" ? onClick(offerTitle, offerId) : null
                }
                isActiveOffer={isActiveOffer}
              />
            );
          // }
          // return null;
        })}
      </ScrollContainer>
      <LeftArrow onClick={handleScrollLeft} >
      <img
      src={leftimage} 
      style={{width:"20px"}}/>
      </LeftArrow>
      <RightArrow onClick={handleScrollRight} >
        
      <img
         src={rightimage}
         style={{width:"20px"}}
         />
      </RightArrow>
    </div>
  );
}

export default HorizontalScroll;



// WEBPACK FOOTER //
// ./src/components/horizontalScroll/HorizontalScroll.js